"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Managed = void 0;
var tslib_1 = require("tslib");
var enumerable_1 = require("../util/enumerable");
var Enhancer_1 = require("./Enhancer");
var intersection_1 = require("../intersection");
var Managed = /** @class */ (function () {
    /**
     * The default constructor, copy all given properties to this object
     * @param properties - The optional properties to copy
     */
    function Managed(properties) {
        Managed.init(this, properties);
    }
    /**
     * Initialize the given instance
     * @param instance The managed instance to initialize
     * @param properties The optional properties to set on the instance
     */
    Managed.init = function (instance, properties) {
        var type = Enhancer_1.Enhancer.getBaqendType(instance.constructor);
        if (type.isEntity) {
            Object.defineProperty(instance, '_metadata', {
                value: intersection_1.Metadata.create(type),
                configurable: true,
            });
        }
        if (properties) {
            Object.assign(instance, properties);
        }
    };
    /**
     * Creates a subclass of this class
     * @param {Class<*>} childClass
     * @return {Class<*>} The extended child class
     */
    Managed.extend = function (childClass) {
        // eslint-disable-next-line no-param-reassign
        childClass.prototype = Object.create(this.prototype, {
            constructor: {
                value: childClass,
                configurable: true,
                writable: true,
            },
        });
        // eslint-disable-next-line no-param-reassign
        childClass.extend = Managed.extend;
        return childClass;
    };
    /**
     * Returns this object identifier or the baqend type of this object
     * @return the object id or type whatever is available
     */
    Managed.prototype.toString = function () {
        var type = Enhancer_1.Enhancer.getBaqendType(this.constructor);
        return type.ref;
    };
    /**
     * Converts the managed object to an JSON-Object.
     * @return JSON-Object
     * @method
     */
    Managed.prototype.toJSON = function () {
        var type = Enhancer_1.Enhancer.getBaqendType(this.constructor);
        return type.toJsonValue(intersection_1.Metadata.create(type), this, { persisting: false });
    };
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], Managed.prototype, "toString", null);
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], Managed.prototype, "toJSON", null);
    return Managed;
}());
exports.Managed = Managed;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFuYWdlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1hbmFnZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLGlEQUFnRDtBQUVoRCx1Q0FBc0M7QUFDdEMsZ0RBQTJDO0FBZTNDO0lBdUNFOzs7T0FHRztJQUNILGlCQUFZLFVBQXdDO1FBQ2xELE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLFVBQVUsQ0FBQyxDQUFDO0lBQ2pDLENBQUM7SUE1Q0Q7Ozs7T0FJRztJQUNJLFlBQUksR0FBWCxVQUFZLFFBQWlCLEVBQUUsVUFBd0M7UUFDckUsSUFBTSxJQUFJLEdBQUcsbUJBQVEsQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBRSxDQUFDO1FBQzNELElBQUksSUFBSSxDQUFDLFFBQVEsRUFBRTtZQUNqQixNQUFNLENBQUMsY0FBYyxDQUFDLFFBQVEsRUFBRSxXQUFXLEVBQUU7Z0JBQzNDLEtBQUssRUFBRSx1QkFBUSxDQUFDLE1BQU0sQ0FBQyxJQUF1QixDQUFDO2dCQUMvQyxZQUFZLEVBQUUsSUFBSTthQUNuQixDQUFDLENBQUM7U0FDSjtRQUVELElBQUksVUFBVSxFQUFFO1lBQ2QsTUFBTSxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsVUFBVSxDQUFDLENBQUM7U0FDckM7SUFDSCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLGNBQU0sR0FBYixVQUFjLFVBQWlDO1FBQzdDLDZDQUE2QztRQUM3QyxVQUFVLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsRUFBRTtZQUNuRCxXQUFXLEVBQUU7Z0JBQ1gsS0FBSyxFQUFFLFVBQVU7Z0JBQ2pCLFlBQVksRUFBRSxJQUFJO2dCQUNsQixRQUFRLEVBQUUsSUFBSTthQUNmO1NBQ0YsQ0FBQyxDQUFDO1FBQ0gsNkNBQTZDO1FBQzVDLFVBQWtCLENBQUMsTUFBTSxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUM7UUFDNUMsT0FBTyxVQUFVLENBQUM7SUFDcEIsQ0FBQztJQVVEOzs7T0FHRztJQUVILDBCQUFRLEdBQVI7UUFDRSxJQUFNLElBQUksR0FBRyxtQkFBUSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUM7UUFDdEQsT0FBTyxJQUFLLENBQUMsR0FBRyxDQUFDO0lBQ25CLENBQUM7SUFFRDs7OztPQUlHO0lBRUgsd0JBQU0sR0FBTjtRQUNFLElBQU0sSUFBSSxHQUFHLG1CQUFRLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUUsQ0FBQztRQUN2RCxPQUFPLElBQUksQ0FBQyxXQUFXLENBQUMsdUJBQVEsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxFQUFFLEVBQUUsVUFBVSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDOUUsQ0FBQztJQWREO1FBREMsSUFBQSx1QkFBVSxFQUFDLEtBQUssQ0FBQzsyQ0FJakI7SUFRRDtRQURDLElBQUEsdUJBQVUsRUFBQyxLQUFLLENBQUM7eUNBSWpCO0lBQ0gsY0FBQztDQUFBLEFBbkVELElBbUVDO0FBbkVZLDBCQUFPIn0=